import baseRequest from "../_core/baseRequest";

export default {
    getRegionList: params => {
        return baseRequest.get(`/regions?city=${params.city}`);
    },
    getRegionListByCities: params => {
        return baseRequest.post(`/regions/listbycities`, params);
    },
    updateRegionName: params => {
        return baseRequest.put(`/regions/${params.values.regionsId}`, params.values);
    },
    getRegionGroups: params => {
        return baseRequest.get(
            `/regiongroups?${params?.companyId ? "companyId=" + params.companyId : ""}${
                params?.city ? "&city=" + params.city : ""
            }${params?.upperGroup ? "&upperGroup=" + params.upperGroup : ""}`
        );
    },
    addOrUpdateRegionGroups: params => {
        return baseRequest.put(`/regiongroups`, params.values);
    },
    getUpperGroupsByCompanyIdAndCity: params => {
        return baseRequest.get(
            `/regiongroups/get-upper-groups?${
                params?.companyId ? "companies=" + params.companyId : ""
            }${params.city ? "&city=" + params.city : ""}`
        );
    },
    getUpperGroupsByCities: params => {
        return baseRequest.get(
            `/regiongroups/get-upper-groups-by-cities?${
                params?.companyId ? "companies=" + params.companyId : ""
            }${params.cities ? "&cities=" + params.cities : ""}`
        );
    }
};
